// Popup informativo de alertas de completitud EN VIVO (2026-09-10) — aparece
// justo después de salir de la ficha de un paciente si PatientChartPage.tsx
// detectó, al desmontarse, algún hallazgo de chequeoCompletitudConsulta.ts en
// la consulta de hoy. SIEMPRE informativo, nunca bloquea la navegación (mismo
// criterio que el motor anti-glosa: advertencia, nunca bloqueo duro) — un
// solo botón "Entendido" que limpia el store y cierra, sin "resolver ahora"
// ni redirección forzada. Montado como HERMANO de <AppRoutes/> en App.tsx
// (no dentro de <Routes>) para sobrevivir cualquier navegación posterior.
import type { JSX } from 'react';
import { useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { PASOS_POR_ITEM, TITULO_POR_ITEM } from '@/lib/pasosCalidadHc';
import { getUltimoReporte, limpiarReporte, subscribe } from './alertaCompletitudStore';

export function AlertaCompletitudPopup(): JSX.Element | null {
  const { t } = useTranslation();
  const reporte = useSyncExternalStore(subscribe, getUltimoReporte, () => null);

  if (!reporte || reporte.hallazgos.length === 0) return null;

  return (
    <Dialog open onOpenChange={(v) => !v && limpiarReporte()}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{t('alertaCompletitud.titulo')}</DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          {reporte.hallazgos.map((hallazgo) => (
            <div key={hallazgo.clave} className="rounded-lg border border-border bg-hce-surface p-3">
              <p className="text-sm font-medium text-hce-ink">{TITULO_POR_ITEM[hallazgo.clave]}</p>
              <ul className="mt-1 list-disc space-y-0.5 pl-4 text-sm text-hce-muted">
                {PASOS_POR_ITEM[hallazgo.clave].map((paso) => (
                  <li key={paso}>{paso}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <DialogFooter>
          <Button onClick={() => limpiarReporte()}>{t('alertaCompletitud.entendido')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
